// ===============================================================================
// === Articles ===
// ===============================================================================

// normalizeArticle maps the new RDS shape into the fields the articles V2 UI expects.
export const normalizeArticle = (raw) => {
  if (!raw) return raw;

  const parseContent = (value) => {
    let parsed;
    try {
      parsed = typeof value === "string" ? JSON.parse(value) : value;
    } catch {
      return [];
    }
    if (!Array.isArray(parsed)) {
      return [];
    }

    // Legacy payloads are already flat blocks with contentType/contentValue.
    const looksLegacy = parsed.every(
      (entry) => entry && typeof entry.contentType === "string",
    );
    if (looksLegacy) {
      return parsed;
    }

    // New payloads are section-like objects that contain an inner `content` array.
    return parsed.flatMap((section) => {
      if (!section || !Array.isArray(section.content)) {
        return [];
      }

      return section.content
        .filter((item) => item && typeof item.contentType === "string")
        .map((item) => ({
          contentType: item.contentType,
          // `videoID` holds the Brightcove id for video blocks; it must be part
          // of the fallback chain or video items resolve to an empty value and
          // render nothing.
          contentValue:
            item.contentValue ??
            item.url ??
            item.content ??
            item.videoID ??
            item.title ??
            "",
        }));
    });
  };

  return {
    ...raw,
    // DB stores UTC without timezone marker; append Z so the browser treats it as UTC.
    updated_date: raw.updated_date && `${raw.updated_date.replace(" ", "T")}Z`,
    created_date: raw.created_date && `${raw.created_date.replace(" ", "T")}Z`,
    content: parseContent(raw.content),
  };
};
